import type { ComprobanteFormulario } from '../../hooks/useComprobanteFormulario';
import type { RespaldoTransferencia } from '../../services/enviosCampanaService';
import { mensajeErrorDeNegocio } from '../../utils/erroresDeNegocio';
import { reportarErrorInesperado } from '../../utils/reportarErrorInesperado';

/** Sube el comprobante elegido (una sola vez, aunque se reintente) y lo deja con la forma que piden las operaciones de envíos. */
export async function resolverRespaldoTransferencia(comprobante: ComprobanteFormulario): Promise<RespaldoTransferencia> {
  const respaldo = await comprobante.resolver();
  return { medioPago: respaldo.medio_pago, comprobanteId: respaldo.comprobante_id };
}

/**
 * Lo que se le dice a quien no pudo subir el comprobante. Las reglas de negocio (archivo inválido, cupo de
 * la hora) van en el formulario; una falla del sistema se reporta y devuelve null, porque ya avisó por toast.
 */
export function mensajeDeFalloAlSubir(error: unknown): string | null {
  const deNegocio = mensajeErrorDeNegocio(error);
  if (deNegocio) return deNegocio;
  reportarErrorInesperado(error, 'No pudimos subir el comprobante. Por favor intenta nuevamente.');
  return null;
}
